/***************************************************************
Hawaiian Macadamia Nut Services
12/05/2018
Alexander Self
Mech harvest modal
- Summary of mech. harvest log to be submitted; along with recently submitted logs
***************************************************************/
import MechanicalHarvestDisplay from './mechHarvest_display';
import MechHarvestTable from './mechHarvest_table';
import React from 'react';
const $ = window.$;


const MechHarvestModal = ({ id, selectedField, harvest, previousHarvest, equipmentNo, selectedHarvest, onClick }) => {
  $(document).ready(() => {
    $(`#${id}`).modal();
  });

  return (
    <div id={id} className="modal modal-fixed-footer">
      <div className="modal-content">
        <h4>Mechanical Harvest Log</h4> <hr />
        <div className="row">
          { previousHarvest.length > 0 ?
            <div>
              <span className="flow-text">
                Recent Records for: <b>{ selectedField.field } | Round { harvest.round }</b>
              </span>
              <MechHarvestTable harvest={previousHarvest} field={selectedField} currentHarvest={harvest} totals={true} />
            </div>
            : ''
          }
        </div>
        <div className="row">
          <span className="flow-text blue-text">Review & Submit</span><hr />
          <MechanicalHarvestDisplay selectedField={selectedField}
            harvest={harvest} />
        </div>
      </div>
      <div className="modal-footer">
        <button type="button" className="modal-action modal-close waves-effect waves-red btn-flat">Cancel</button>
        <button className="modal-action modal-close waves-effect waves-green btn-flat"
          id="mech-harvest-create-btn"
          onClick={() => onClick(harvest, previousHarvest, selectedField, equipmentNo, selectedHarvest)}>
          Submit
        </button>
        </div>
    </div>
  );
};

export default MechHarvestModal;



// WEBPACK FOOTER //
// ./src/components/harvest/mechHarvest_modal.jsx